import BaseNotification from '#BASE/components/notification/notification.base.component';
import BetCommonOption from 'XY/components/bet/bet.component.commonOption';
import signalr from 'BASE/common/signalrAdapter';

export default {
    mixins: [
        BaseNotification,
        BetCommonOption,
    ],   
    created() {
        signalr.addWorkOnConnected(() => {
            signalr.betAwardNotifyClient.betAwardNotify.addHandler(result => {
                if (this.awardNotifyAlertStorage()) {
                    return;
                }

                this.add(result);
            });
        });
    }
};